export const discordClientId = '844368685791707176';
export const githubClientId = 'da6c2355e9bfe8f37efa';
export const googleClientId = '249551392486-170u2ta7chhkm177g7693v5dhp8p8gnc.apps.googleusercontent.com';
export const apiBaseUrl = 'https://chiadashboard.com/api';

export const enablePeriodicUpdates = true;
export const requestDiscordGuildPermission = true;